/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSubmissionsCycleInternalV2SubmissionsCyclePost } from '../fn/submissions-cycle-internal-v-2/create-submissions-cycle-internal-v-2-submissions-cycle-post';
import { CreateSubmissionsCycleInternalV2SubmissionsCyclePost$Params } from '../fn/submissions-cycle-internal-v-2/create-submissions-cycle-internal-v-2-submissions-cycle-post';
import { SubmissionsCycle } from '../models/submissions-cycle';
import { updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch } from '../fn/submissions-cycle-internal-v-2/update-submissions-cycle-form-version-internal-v-2-submissions-cycle-id-form-version-patch';
import { UpdateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Params } from '../fn/submissions-cycle-internal-v-2/update-submissions-cycle-form-version-internal-v-2-submissions-cycle-id-form-version-patch';
import { updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch } from '../fn/submissions-cycle-internal-v-2/update-submissions-cycle-internal-v-2-submissions-cycle-id-patch';
import { UpdateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Params } from '../fn/submissions-cycle-internal-v-2/update-submissions-cycle-internal-v-2-submissions-cycle-id-patch';

@Injectable({ providedIn: 'root' })
export class SubmissionsCycleInternalV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createSubmissionsCycleInternalV2SubmissionsCyclePost()` */
  static readonly CreateSubmissionsCycleInternalV2SubmissionsCyclePostPath = '/_internal/v2/submissions-cycle';

  /**
   * Create Submissions Cycle.
   *
   * Create a submissions cycle record.
   * This endpoint creates a new submissions cycle record using the provided data. It validates that
   * the requesting organization is an agridence member. It also checks that the specified form ID and
   * form version ID are valid and that the form version belongs to the given form.
   * Args:
   *     submissions_cycle_in (schemas.SubmissionsCycleCreate): Data required to create a submissions cycle.
   *     org (Any): Organization details resolved via dependency injection.
   * Returns:
   *     Any: The created submissions cycle record as defined in schemas.SubmissionsCycle.
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the provided form ID is invalid.
   *     HTTPException: If the provided form version ID is invalid.
   *     HTTPException: If the form version does not belong to the specified form.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubmissionsCycleInternalV2SubmissionsCyclePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubmissionsCycleInternalV2SubmissionsCyclePost$Response(params: CreateSubmissionsCycleInternalV2SubmissionsCyclePost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycle>> {
    return createSubmissionsCycleInternalV2SubmissionsCyclePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Submissions Cycle.
   *
   * Create a submissions cycle record.
   * This endpoint creates a new submissions cycle record using the provided data. It validates that
   * the requesting organization is an agridence member. It also checks that the specified form ID and
   * form version ID are valid and that the form version belongs to the given form.
   * Args:
   *     submissions_cycle_in (schemas.SubmissionsCycleCreate): Data required to create a submissions cycle.
   *     org (Any): Organization details resolved via dependency injection.
   * Returns:
   *     Any: The created submissions cycle record as defined in schemas.SubmissionsCycle.
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the provided form ID is invalid.
   *     HTTPException: If the provided form version ID is invalid.
   *     HTTPException: If the form version does not belong to the specified form.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubmissionsCycleInternalV2SubmissionsCyclePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubmissionsCycleInternalV2SubmissionsCyclePost(params: CreateSubmissionsCycleInternalV2SubmissionsCyclePost$Params, context?: HttpContext): Observable<SubmissionsCycle> {
    return this.createSubmissionsCycleInternalV2SubmissionsCyclePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsCycle>): SubmissionsCycle => r.body)
    );
  }

  /** Path part for operation `updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch()` */
  static readonly UpdateSubmissionsCycleInternalV2SubmissionsCycleIdPatchPath = '/_internal/v2/submissions-cycle/{id}';

  /**
   * Update Submissions Cycle.
   *
   * Update a submissions cycle record by its ID.
   * This endpoint updates an existing submissions cycle record with new data provided in the request.
   * It ensures that the requesting organization is an agridence member before performing the update.
   * Args:
   *     org (Any): Organization details resolved via dependency injection.
   *     submissions_cycle_in (schemas.SubmissionsCycleUpdateIn): The update data for the submissions cycle.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle to update.
   * Returns:
   *     Any: The updated submissions cycle record as defined in schemas.SubmissionsCycle.
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Response(params: UpdateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycle>> {
    return updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Submissions Cycle.
   *
   * Update a submissions cycle record by its ID.
   * This endpoint updates an existing submissions cycle record with new data provided in the request.
   * It ensures that the requesting organization is an agridence member before performing the update.
   * Args:
   *     org (Any): Organization details resolved via dependency injection.
   *     submissions_cycle_in (schemas.SubmissionsCycleUpdateIn): The update data for the submissions cycle.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle to update.
   * Returns:
   *     Any: The updated submissions cycle record as defined in schemas.SubmissionsCycle.
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch(params: UpdateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Params, context?: HttpContext): Observable<SubmissionsCycle> {
    return this.updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsCycle>): SubmissionsCycle => r.body)
    );
  }

  /** Path part for operation `updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch()` */
  static readonly UpdateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatchPath = '/_internal/v2/submissions-cycle/{id}/form-version';

  /**
   * Update Submissions Cycle Form Version.
   *
   * Update the form version of a submissions cycle.
   * This endpoint updates the form version of an existing submissions cycle record.
   * It verifies that the organization is an agridence member, that the new form version ID is valid,
   * and that it corresponds to the form associated with the submissions cycle.
   * Args:
   *     org (Any): Organization details resolved via dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle to update.
   *     form_version (PydanticObjectId): The new form version identifier to be set.
   * Returns:
   *     Any: The updated submissions cycle record as defined in schemas.SubmissionsCycle.
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the new form version ID is invalid.
   *     HTTPException: If the new form version does not belong to the form associated with the submissions cycle.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Response(params: UpdateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycle>> {
    return updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Submissions Cycle Form Version.
   *
   * Update the form version of a submissions cycle.
   * This endpoint updates the form version of an existing submissions cycle record.
   * It verifies that the organization is an agridence member, that the new form version ID is valid,
   * and that it corresponds to the form associated with the submissions cycle.
   * Args:
   *     org (Any): Organization details resolved via dependency injection.
   *     id (PydanticObjectId): The unique identifier of the submissions cycle to update.
   *     form_version (PydanticObjectId): The new form version identifier to be set.
   * Returns:
   *     Any: The updated submissions cycle record as defined in schemas.SubmissionsCycle.
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the new form version ID is invalid.
   *     HTTPException: If the new form version does not belong to the form associated with the submissions cycle.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch(params: UpdateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Params, context?: HttpContext): Observable<SubmissionsCycle> {
    return this.updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionsCycle>): SubmissionsCycle => r.body)
    );
  }

}
